import React from "react";
import { Link } from "react-router-dom";
import { MessageCircle, Phone, Mail, MapPin, Instagram } from "lucide-react";
import { COMPANY, buildWhatsAppLink } from "@/lib/constants";
import Logo from "@/components/Logo";

const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0F172A] text-slate-300">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Logo variant="footer" />
            <p className="mt-5 text-slate-400 leading-relaxed max-w-md">
              Spezialist für Leasingrückläufer: Aufbereitung, Smart Repair und Komplett-Service –
              damit Ihre Leasingrückgabe ohne teure Nachzahlung verläuft.
            </p>
            <a
              href={buildWhatsAppLink()}
              target="_blank"
              rel="noreferrer"
              data-testid="footer-whatsapp-cta"
              className="mt-6 inline-flex items-center gap-2 bg-[#25D366] text-white rounded-full px-6 py-3 text-sm font-semibold hover:bg-[#1DAE54] transition-colors"
            >
              <MessageCircle className="w-4 h-4" /> WhatsApp Beratung
            </a>

            {/* Social row */}
            <div className="mt-6 flex items-center gap-3">
              <span className="text-xs uppercase tracking-wider text-slate-500 font-semibold">Folgen Sie uns</span>
              <a
                href={COMPANY.instagram}
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram-link"
                aria-label="Instagram"
                className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-gradient-to-br from-[#F58529] via-[#DD2A7B] to-[#8134AF] text-white hover:scale-110 transition-transform shadow-lg"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href={COMPANY.instagram}
                target="_blank"
                rel="noreferrer"
                className="text-sm text-slate-300 hover:text-[#1FA3B5] transition-colors"
              >
                {COMPANY.instagramHandle}
              </a>
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Leistungen</h4>
            <ul className="space-y-3 text-sm">
              <li><a href="#leistungen" className="hover:text-[#1FA3B5] transition-colors">Leasingrückgabe Service</a></li>
              <li><a href="#leistungen" className="hover:text-[#1FA3B5] transition-colors">Aufbereitung Innen & Außen</a></li>
              <li><a href="#leistungen" className="hover:text-[#1FA3B5] transition-colors">Smart Repair</a></li>
              <li><a href="#leistungen" className="hover:text-[#1FA3B5] transition-colors">Karosserie & Lack</a></li>
              <li><a href="#leistungen" className="hover:text-[#1FA3B5] transition-colors">Premium Hol- & Bringdienst</a></li>
              <li><a href="#spar-check" className="hover:text-[#1FA3B5] transition-colors">60-Sek. Spar-Check</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Kontakt</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#1FA3B5] flex-shrink-0" />
                <span>{COMPANY.street}<br />{COMPANY.zip} {COMPANY.city}</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#1FA3B5] flex-shrink-0" />
                <a href={`tel:${COMPANY.phoneIntl.replace(/\s/g, "")}`} className="hover:text-[#1FA3B5] transition-colors">
                  {COMPANY.phoneDisplay}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#1FA3B5] flex-shrink-0" />
                <a href={`mailto:${COMPANY.email}`} className="hover:text-[#1FA3B5] transition-colors">
                  {COMPANY.email}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4 text-sm">
          <p className="text-slate-500">© {new Date().getFullYear()} {COMPANY.name}. Alle Rechte vorbehalten.</p>
          <div className="flex items-center gap-6">
            <Link to="/impressum" data-testid="footer-impressum-link" className="text-slate-400 hover:text-[#1FA3B5] transition-colors">Impressum</Link>
            <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="text-slate-400 hover:text-[#1FA3B5] transition-colors">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
